import React from 'react';
import { useFilter } from './filterProvider';

interface FilterPanelProps {
  children: React.ReactNode;
}

const FilterPanel: React.FC<FilterPanelProps> = ( { children } ) => {
  const { isCollapsed } = useFilter();

  return (
    <>
      {!isCollapsed && (
        <>
          { children }
        </>
      )}
    </>
  );
};

export { FilterPanel };
